import { render, staticRenderFns } from "./PopoverConfirm.vue?vue&type=template&id=7b474dd1"
import script from "./PopoverConfirm.vue?vue&type=script&lang=js"
export * from "./PopoverConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports